import {GroupToursRFQFormData, PostalAddress} from './definitions';

const POSTAL_ADDRESS: PostalAddress = {
	streetAddress: 'Poßmoorweg',
	postalCode: '22301',
	addressLocality: 'Hamburg',
	addressCountry: null,
	contactType: 'dienstlich'
};

const DEFAULT_PROPS: GroupToursRFQFormData = {
	customer: {
		honorificPrefix: null,
		salutation: 'Frau',
		givenName: 'Jane',
		familyName: 'Doe',
		address: POSTAL_ADDRESS,
		email: 'jane@d.oe',
		telephone: '1234567890',
	},
	participant: {
		name: 'Twilight Zone',
		additionalType: 'Private Gruppe',
		address: POSTAL_ADDRESS
	},
	hidden: {
		quoteRequest: {
			groupedTrips: {
				names: ['England'],
			},
		},
	},
	quoteRequest: {
		groupedTrips: [
			{name: 'England', trips: ['Natur pur in England und Wales (ReiseID: 1467)']}
		],
		offerPrice: '999,95 €',
		offerIncludesAccommodation: ['Luxus-Class 5*', 'Comfort-Class 3*/4*'],
		offerIncludesTransportation: ['Bahnreise', 'Eigenanreise', 'Flugreise'],
		offerIncludesParticipants: {
			totalAmountOfParticipants: 24,
			amountOfParticipantsInSingleRooms: 4,
			amountOfParticipantsInDoubleRooms: 0,
			amountOfParticipantsInMultiBedRooms: 20
		},
		arrivalTime: '15.09.2020',
		departureTime: '19.09.2020',
		departureStation: 'Hamburg',
		departureAirport: 'Hamburg',
		departureBusStation: null,
		duration: 4,
		timeFlexibility: null,
		alternativeArrivalTime: null,
		alternativeDepartureTime: null,
		alternativeDuration: null,
		alternativeTimeFlexibility: null,
	},
	newsletter: false,
	referer: 'Mir liegt der Katalog vor',
	description: 'Bitte nur vormittags zurückrufen.',
};

export default DEFAULT_PROPS;
